module.exports = __webpack_public_path__ + "static/img/xgdh2.6768029.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/xgdh2.png
// module id = 393
// module chunks = 0